import React from 'react';
import { FadeInView } from '../ui/FadeInView';
export function ProblemSection() {
  return <section className="py-16 md:py-24 px-4 bg-[#1B4332] text-[#FAF7F2] relative overflow-hidden" data-id="element-224">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-225">
        <FadeInView data-id="element-226">
          <h2 className="text-3xl md:text-5xl font-bold mb-10 leading-tight text-center" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-227">
            Si tienes una Air Fryer en casa, esto te va a sonar familiar:
          </h2>

          <div className="space-y-4 text-lg md:text-xl text-[#FAF7F2]/90 mb-12" data-id="element-228">
            <p className="flex items-start gap-3" data-id="element-229">
              <span className="text-red-400 flex-shrink-0" data-id="element-230">❌</span>
              <span data-id="element-231">
                Llevas semanas comiendo lo mismo — pollo hervido, ensalada y
                brócoli — y ya no puedes más
              </span>
            </p>
            <p className="flex items-start gap-3" data-id="element-232">
              <span className="text-red-400 flex-shrink-0" data-id="element-233">❌</span>
              <span data-id="element-234">
                Empiezas la dieta el lunes con fuerza y el jueves ya has tirado
                la toalla
              </span>
            </p>
            <p className="flex items-start gap-3" data-id="element-235">
              <span className="text-red-400 flex-shrink-0" data-id="element-236">❌</span>
              <span data-id="element-237">
                Tu Air Fryer lleva meses cogiendo polvo porque no sabes qué más
                cocinar con ella
              </span>
            </p>
            <p className="flex items-start gap-3" data-id="element-238">
              <span className="text-red-400 flex-shrink-0" data-id="element-239">❌</span>
              <span data-id="element-240">
                Abres la nevera a las 10 de la noche y el antojo te gana la
                batalla
              </span>
            </p>
            <p className="flex items-start gap-3" data-id="element-241">
              <span className="text-red-400 flex-shrink-0" data-id="element-242">❌</span>
              <span data-id="element-243">
                Comes sano durante el día y luego lo arruinas todo en la cena
              </span>
            </p>
            <p className="flex items-start gap-3" data-id="element-244">
              <span className="text-red-400 flex-shrink-0" data-id="element-245">❌</span>
              <span data-id="element-246">
                Has probado dietas, apps y planes de nutricionista y siempre
                acabas en el mismo sitio
              </span>
            </p>
          </div>

          <p className="text-2xl md:text-3xl font-bold text-[#D4A853] mb-8 text-center" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-247">
            ¿Cuántas dietas más vas a empezar el lunes para abandonarlas el
            jueves?
          </p>

          <p className="text-lg md:text-xl text-[#FAF7F2]/80 mb-16 text-center leading-relaxed" data-id="element-248">
            Da igual si estás en Madrid, en Barcelona, en Sevilla o en cualquier
            ciudad de España. El problema es exactamente el mismo. Y la solución
            también.
          </p>

          <div className="bg-[#2D5016] p-8 md:p-10 rounded-3xl border border-[#D4A853]/10 shadow-xl mb-12" data-id="element-249">
            <h3 className="text-3xl md:text-4xl font-bold text-[#D4A853] mb-6" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-250">
              El problema no eres tú. Es el método.
            </h3>

            <p className="text-xl md:text-2xl text-[#FAF7F2] mb-6 leading-relaxed" data-id="element-251">
              Las dietas tradicionales fracasan por una sola razón:
            </p>

            <p className="text-2xl md:text-3xl font-bold text-[#FAF7F2] mb-8" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-252">
              Te obligan a comer comida que no te gusta.
            </p>

            <p className="text-lg text-[#FAF7F2]/80 leading-relaxed" data-id="element-253">
              Nadie puede mantener una vida entera de pollo hervido y lechuga.
              Nadie. No es falta de fuerza de voluntad. Es que el cerebro humano
              no está diseñado para privarse de placer indefinidamente.
            </p>
          </div>

          <p className="text-lg md:text-xl text-[#FAF7F2]/70 mb-6 text-center" data-id="element-254">
            Hay una razón por la que el 95% de las personas que hacen dieta
            recuperan el peso en menos de un año.
          </p>

          <p className="text-2xl md:text-3xl font-bold text-[#D4A853] mb-12 text-center" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-255">
            No es la comida. Es el sistema.
          </p>

          <div className="bg-[#FAF7F2]/5 p-8 md:p-10 rounded-3xl border border-[#FAF7F2]/10" data-id="element-256">
            <p className="text-xl md:text-2xl text-[#FAF7F2]/90 mb-6 leading-relaxed" data-id="element-257">
              La única manera de adelgazar de forma permanente es con un sistema
              que puedas mantener sin sufrimiento. Uno que te deje comer rico.
              Uno que no te robe el fin de semana. Uno que funcione para toda la
              familia.
            </p>
            <p className="text-2xl md:text-3xl font-bold text-[#D4A853]" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-258">
              Eso es exactamente lo que hace Adelgaza con Air Fryer.
            </p>
          </div>
        </FadeInView>
      </div>
    </section>;
}